import { render, staticRenderFns } from "./ConnectedSocialCard.vue?vue&type=template&id=70e640c3&scoped=true&"
import script from "./ConnectedSocialCard.vue?vue&type=script&lang=js&"
export * from "./ConnectedSocialCard.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedSocialCard.scss?vue&type=style&index=0&id=70e640c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e640c3",
  null
  
)

export default component.exports